export default `Analyze the provided search terms data to identify opportunities for new negative keywords that
will improve account efficiency Create a clean well-formatted negative keyword strategy that

1 Focuses on search terms with significant spend $30+ but zero or poor conversion performance

2 Groups non-converting terms into clear categories
  - Competitor brands not carried e.g. competitor names
  - Irrelevant product types products you don't sell
  - Location qualifiers when inappropriate
  - Qualification terms that indicate poor intent

3 For each recommended negative keyword
  - Present in a clean standard format with normal punctuation
  - Clearly show the exact format to add exact match [term] phrase match "term" or broad match term
  - Include a clean data table showing search term cost impressions clicks conversions
  - Clearly state which campaign(s) the negative should be applied to

4 Structure recommendations in a clean hierarchical format
  - HIGH PRIORITY significant wasted spend >$50
  - MEDIUM PRIORITY moderate wasted spend $20-50
  - LOW PRIORITY minor wasted spend <$20

5 For each recommendation provide
  - Simple clear reasoning with minimal text
  - Clear implementation instructions
  - Estimated monthly savings

6 End with a simple implementation roadmap in standard table format no special characters

Use only standard characters and formatting in your response Do not use unusual dashes bullets
or special formatting that might not display correctly Keep tables simple with standard spacing
`;
